'use client';

import { usePathname } from 'next/navigation';
import { useState, CSSProperties, useLayoutEffect } from 'react';
import { css } from 'styled-components';

function recuperarPathnamePelaURL(pathname: string): string {
  if (pathname.endsWith('/customizar-plano')) return '/customizar-plano';
  if (pathname.includes('/pedido-avulso')) return '/pedido-avulso';
  if (pathname.includes('/pedido-plano')) return '/pedido-plano';
  if (pathname.endsWith('/minhas-compras')) return '/minhas-compras';
  if (pathname.startsWith('/plano')) return '/plano';
  if (pathname.startsWith('/produto')) return '/produto';
  if (pathname.startsWith('/assinatura')) return '/assinatura';
  if (
    pathname.startsWith('/minha-conta/minhas-compras/refazer-pedido') &&
    pathname.endsWith('/cadastrar-novo-cartao')
  )
    return '/refazer-pedido/cadastrar-novo-cartao';
  if (pathname.startsWith('/minha-conta')) return '/minha-conta';
  if (pathname.endsWith('/cadastrar-novo-cartao'))
    return '/cadastrar-novo-cartao';
  if (pathname.startsWith('/noticias') || pathname.startsWith('/criticas'))
    return '/publicacao';
  return pathname;
}

export const ROUTE_TO_BREAKPOINT: Record<string, number> = {
  '/': 980,
  '/plano': 790,
  '/produto': 790,
  '/ajuda': 874,
  '/sacola': 940,
  '/minha-conta': 874,
  '/minhas-compras': 990,
  '/pedido-plano': 1008,
  '/pedido-avulso': 1008,
  '/customizar-plano': 1050,
  '/cadastrar-novo-cartao': 690,
  '/assinatura': 650,
  '/refazer-pedido/cadastrar-novo-cartao': 970,
  '/publicacao': 1008,
};

export const breakpointDesktopDefault: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 1280,
  margin: '0 auto',
  flex: 1,
  minHeight: '100vh',
};

export const breakpointDesktopDefaultStyledComponent = css`
  display: flex;
  flex-direction: column;
  max-width: 1280px;
  margin: 0 auto;
`;

const valorPadraoBreakpoint = 768;
export type Breakpoints = 'mobile' | 'desktop';

export default function useBreakpoint(): {
  widthWindow: number;
  breakpoint: Breakpoints;
} {
  const [breakpoint, setBreakpoint] = useState<Breakpoints>('desktop');
  const [widthWindow, setWidthWindow] = useState<number>(0);

  const caminhoURL = usePathname();

  useLayoutEffect(() => {
    const resolvedBreakpoint =
      ROUTE_TO_BREAKPOINT[recuperarPathnamePelaURL(caminhoURL)] ??
      valorPadraoBreakpoint;

    const mediaQuery = window.matchMedia(
      `(max-width: ${resolvedBreakpoint}px)`,
    );

    function updatebreakpoint() {
      setBreakpoint(mediaQuery.matches ? 'mobile' : 'desktop');
      setWidthWindow(window.innerWidth);
    }

    updatebreakpoint();
    window.addEventListener('resize', updatebreakpoint);

    return () => window.removeEventListener('resize', updatebreakpoint);
  }, [caminhoURL]);

  return { widthWindow, breakpoint };
}
